module.exports = __webpack_public_path__ + "static/img/fail.ed3ec20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myprize/fail.png
// module id = i+9p
// module chunks = 1